import { forwardRef, useRef, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import PageHeader from '../../includes/PageHeader';
import TapIcon from '../../../services/TapIcon';
import {IAM_API_BASE_URL_2, IAM_COUNTERLOG_URL, ISC_SALES_INVOICE_URL } from '../../../services/TapApiUrls';
import HttpAPICall from '../../../services/HttpAPICall';
import Loader from '../../../components/ui/Loader/Loader';
import TapHelper from '../../../services/TapHelper';
import DateService from '../../../services/DateService';
import { DisplayListPagination, DisplaySearchCriteria, PeriodSelectionWithCustom } from '../../../components/TapUi';
import download from '../../../services/DownloadFile';
import CounterlogDetail from './CounterlogDetail';
import CounterlogSearchModal from './CounterlogSearchModal';
import AssetHeader from '../../assets/includes/AssetHeader';
import { toast } from 'react-toastify';
import AssetDetailHorizontalCard from '../../assets/includes/AssetDetailHorizontalCard';
import { Collapse, Modal } from 'bootstrap';
import uuid from 'react-uuid';
import moment from 'moment';
import InputAssetSearch from '../../includes/ui/InputAssetSearch';
import TapSelect from '../../../components/ui/TapSelect';
import TapInput from '../../../components/ui/TapInput';

const CounterlogHistoryList                  =   forwardRef((props, ref) => {

       const access_token               =   useSelector(state => state.auth.access_token);
        const iamAssetType              =   useSelector(state => state.app.asset_type);
        const iamAssetMatrix            =   useSelector(state => state.app.asset_matrix);
        const all_period                =   useSelector(state => state.app.all_periods ? state.app.all_periods: [] );
        const iam_user_sites            =   useSelector(state => state.app.user_sites || []);

    let initListData                        =   {
        loading                                 :   false,
        items                                   :   [],
        sites                                   :   [],
        meta                                    :   null,
        page                                    :   1
    };
    let initVoucherData                     =   {
        transaction_id                          :   '',
        loading                                 :   false,
        data                                    :   null
    };
   
    let itemListUrl                         =   IAM_COUNTERLOG_URL + "/transactions/list";
    let itemFormDataUrl                     =   IAM_COUNTERLOG_URL + "/transactions/form_data";

 
    const criteriaRef                                    =   useRef() ;
    const searchModalElem                                =   useRef();
    const counterlogSearchModalElem                      =   useRef(null);
    const counterlogSearchModal                          =   useRef(null);

     const counterlogSearchInitState = {
            'search_transaction_id'             : '',
            'search_site_ids'                   : [],
            'date_range'                        : '',
            'date_range_start'                  : null,
            'date_range_end'                    : null,
            'entry_date_range'                  : '',
            'entry_date_range_start'            : null,
            'entry_date_range_end'              : null,
            'activity_transaction_delay'        : '',
            search_asset_ids                    : [],
            search_asset_type_ids               : [],
            search_asset_matrix_ids             : [],
        };
    
        const counterlogSearchFormLabel = {
            'search_site_ids'                   : 'Site : ',
            'search_transaction_id'             : 'Transaction ID : ',
            'date_range'                        : 'Transaction Period : ',
            'entry_date_range'                  : 'Date of Entry : ',
            'activity_transaction_delay'        : 'Transaction Delay : ',
            search_asset_ids                    : 'Assets : ',
            search_asset_type_ids               : 'Asset Type : ',
            search_asset_matrix_ids             : 'Asset Matrix : ',
        };
    
        const [modalId, setModalId]                                   = useState(uuid());
        const [formId, setFormId]                                     = useState(uuid());
        const [counterlogSearchForm, setCounterlogSearchForm]           = useState({...counterlogSearchInitState});
        const [counterlogSearchParams, setCounterlogSearchParams]       = useState(null);
        const [searchedAssets, setSearchedAssets]                       = useState([]);
        const [iam_group_sites, setIam_group_sites]                     = useState([]);
        const [allPeriods, setAllPeriods]                               = useState([...all_period, { key: 'custom', display: 'Custom Date Range' }]);
        const [allTransactionDelay, setAllTransactionDelay]             = useState([]);
        const [iam_asset_types, setIam_asset_types]                     = useState([]);
        const [iam_asset_matrix, setIam_asset_matrix]                   = useState([]);
        const [assetId,   setAssetId]                                   = useState(null)
        const [itemsData, setItemsData]                                 = useState({...initListData});
        const [voucherData, setVoucherData]                             = useState({...initVoucherData});
        const [assetDetail, setAssetDetail]                             = useState([]);
        const [assetLoading, setAssetLoading]                           = useState(false);
        const [formSearchedElems, setFormSearchedElems]                 = useState([]);
        const [searchParams, setSearchParams]                           = useState({});
        const [paramHandle, setParamHandle]                             = useState(false);
        const [criteriaHeight ,setCriteriaHeight]                       = useState(0)        

        const updateCriteriaHeight = () => {
        if (criteriaRef.current) {
            const height = criteriaRef.current.offsetHeight;
                if (criteriaHeight !== height) {
                    setCriteriaHeight(height)
             }
            }
        };
     

    useEffect(() => {
        updateCriteriaHeight()
        setAssetId(props.match?.params?.id);
        searchFormDataInit();
        
        if (props.match?.params?.id) {
            getAsssetDetails(props.match?.params?.id);
        }
        counterlogSearchModalElem.current = document.getElementById(modalId);
        counterlogSearchModal.current = new Modal(counterlogSearchModalElem.current, { keyboard: false, backdrop: false });
        return () => {
            if (counterlogSearchModal.current) {
                counterlogSearchModal.current.dispose();
            }
        };
    }, []);
    useEffect(() => {
        if (paramHandle) {
            counterlogSearchFormSubmit()
            setParamHandle(false)
        }
    }, [paramHandle])

   const counterlogSearchModalOpen = () => {
        if (counterlogSearchModal.current) {
            counterlogSearchModal.current.show();
        }
    };

    const counterlogSearchModalClose = () => {
        if (counterlogSearchModal.current) {
            counterlogSearchModal.current.hide();
        }
    };
    const searchFormDataInit = () => {
        setItemsData(pd => ({ ...pd, loading: true }));
        HttpAPICall.withAthorization('GET', itemFormDataUrl, access_token, {})
            .then((response) => {
                let respData = response.data;
                setAllTransactionDelay(respData && respData.transactional_delay ? respData.transactional_delay.map((td) => ({ value: td.key, label: td.text })) : []);
                setIam_group_sites(iam_user_sites.map((s) => ({ value: s.id, label: `${s.site_name} (${s.site_code})` })),)
                setIam_asset_matrix(iamAssetMatrix.length > 0
                    ? iamAssetMatrix.map(am => ({ label: am.asset_matrix_unique_id, value: am.id }))
                    : [],)
                setIam_asset_types(iamAssetType.length > 0
                    ? iamAssetType.map(at => ({ label: at.asset_type_name, value: at.id }))
                    : [])
                let ParamObject = new URLSearchParams(props?.location?.search);

                if (ParamObject.get('search_site_ids') || ParamObject.get('entry_date_range') || ParamObject.get('activity_transaction_delay')) {
                    let updateFilterForm = { 'entry_date_range': ParamObject.get('entry_date_range'), 'activity_transaction_delay': ParamObject.get('activity_transaction_delay') };
                    if (ParamObject.get('search_site_ids')) {
                        updateFilterForm['search_site_ids'] = [ParamObject.get('search_site_ids')]
                    }
                    setCounterlogSearchForm(prev => ({ ...prev, ...updateFilterForm }));
                    setParamHandle(true)
                }
                else {
                    let asset_id = props.match?.params?.id ? { search_asset_ids: [props.match.params.id] } : {};
                    loadItemsData(1,  asset_id);
                }
            });

    };
    const formInputHandler = (e, formName) => {
        setCounterlogSearchForm(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };

    const tapSelectChange = (selectedOption, formName, fieldName) => {
        const value = Array.isArray(selectedOption) ?
            selectedOption.map(option => option.value) :
            (selectedOption ? selectedOption.value : '');

        setCounterlogSearchForm(prev => ({
            ...prev,
            [fieldName]: value
        }));
    };
    
        const counterlogSearchFormSubmit = (event = null) => {
            event && event.preventDefault();
            
            // Get All Keys
            let searchFormKeys = Object.keys(counterlogSearchForm);
            let searchedElems = [];
            let searchParams = {};
            
            searchFormKeys.forEach((key) => {
    
                let label = counterlogSearchFormLabel[key];
                let value = counterlogSearchForm[key];
                
                if(value && value !== "Invalid date" && value.length > 0) {
                    searchParams[key] = value;
                     if (assetId && (key === 'search_asset_ids' || key === 'search_asset_type_ids' || key === 'search_asset_matrix_ids')) {
                    return;
                }
                
                    if(label) {
                        let show_val = value;
                        if(key == 'search_site_ids') {
                            show_val = iam_group_sites.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                        }
                        if(key == 'search_transaction_id') {
                            show_val = counterlogSearchForm.search_transaction_id || '';
                        }
                        if(key == 'activity_transaction_delay') {
                            show_val = allTransactionDelay.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                        }
                        if(key == 'search_asset_ids') {
                            show_val            =   searchedAssets ? searchedAssets.map(s => s.display_label).join(', ') : '';
                        }
                          if(key == 'search_asset_type_ids') {
                            show_val            =   iam_asset_types.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                        }
                        if(key == 'search_asset_matrix_ids') {
                            show_val            = iam_asset_matrix.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                        }
                        
                        if(key == 'date_range') {
                            let start_range = moment(counterlogSearchForm.date_range_start).format('DD-MMM-YYYY');
                            let end_range = moment(counterlogSearchForm.date_range_end).format('DD-MMM-YYYY');
                            let display_custom = `Custom Date Range (${start_range} - ${end_range})`;
                            show_val = allPeriods.filter((s) => value.includes(s.key)).map(s => s.display_with_date ? s.display_with_date : display_custom);
                        }
                        if(key == 'entry_date_range') {
                            let start_range = moment(counterlogSearchForm.entry_date_range_start ).format('DD-MMM-YYYY');
                            let end_range = moment(counterlogSearchForm.entry_date_range_end).format('DD-MMM-YYYY');
                            let display_custom = `Custom Date Range (${start_range} - ${end_range})`;
                            show_val = allPeriods.filter((s) => value.includes(s.key)).map(s => s.display_with_date ? s.display_with_date : display_custom);
                            
                        }
                        searchedElems.push(label + `<b>${show_val}</b>`);
                    }
                }
            });
            
            setCounterlogSearchParams(searchParams);
            setFormSearchedElems(searchedElems);
            counterlogSearchModalClose();
            loadItemsData(1,searchParams)
        };

        const loadItemsData = (page = 1, newSearchParams = null) => {
            
            setItemsData(pd => ({ ...pd, loading: true, page: page }));
            let asset_id = props.match?.params?.id ? props.match.params.id : "";
            let params = {
                page: page,
                search_asset_ids: asset_id ? [asset_id] : []
            };
            if (typeof newSearchParams === 'object') {
                setSearchParams(pre=> ({...pre , newSearchParams}));
                params = {
                    ...params,
                    ...newSearchParams
                };
            } else {
                params = {
                    ...params,
                    ...searchParams
                };
            }
            HttpAPICall.withAthorization('GET', itemListUrl, access_token, params, {}, (response) => {
                let respData = response.data;
                let meta = TapHelper.pick(respData, ['from', 'to', 'total', 'last_page', 'per_page', 'current_page']);
                setItemsData(pd => ({ ...pd, items: respData.data, meta: meta, sites: response.data.sites }));
            }).then(() => {
                setItemsData(pd => ({ ...pd, loading: false }));
            });
    }

    const handleSearchClear = () => {
        const emptySearchParams = props.match?.params?.id 
            ? { search_asset_ids: [props.match?.params?.id] } 
            : {};
        setSearchParams(emptySearchParams);
         setCounterlogSearchForm({
            ...counterlogSearchInitState,
            search_asset_ids: props.assetId ? [props.assetId] : []
        });
        setSearchedAssets([]);
        setFormSearchedElems([]);
        loadItemsData(1, emptySearchParams);
        setCriteriaHeight(0)
    };
    const listSearchModalInit = () => {
        if (searchModalElem.current) {
            searchModalElem.current.initModalHandler();
        }
    }
      const getAsssetDetails                =   (id)  =>  {
            let Id  = id ? id  : assetId
            setAssetLoading(true)
            HttpAPICall.withAthorization('GET', IAM_API_BASE_URL_2 + '/asset/' + Id, access_token , {}, {}, (response) => {
                setAssetDetail(response.data.data)
            }, (error) => {
                toast.error(error?.msg, { position: toast.POSITION.TOP_RIGHT });
            }).then(() => { setAssetLoading(false)})
        }
    
    const  pageTitleBarJsx          =   ()  =>  {
           let obj = {'search_asset_id' : assetDetail?.asset_id, 'asset_name' : `${assetDetail?.name} (${assetDetail?.asset_code})`};
           return (<div className="page_title row m0">
               <div className="col-12 asset_collapse">
                   <h3>{assetDetail?.name}</h3>
                   <AssetHeader  assetDetail={assetDetail} afterChangeStatus={getAsssetDetails} parentProps={props} />
               </div>
           </div>);
       }
       
    const horizontalAssetCardJsx      =       ()      =>  {
        
        return (<div> 
            <div id="assetCard" className="collapse pr-1 mt-1"  aria-expanded="true" >
            {assetLoading ? <div className='text-center pt-1'><Loader/></div>
            : <AssetDetailHorizontalCard assetDetail={assetDetail} />}
        </div>
        </div>)
    }
    const counterlogTablejsx              =   ()   =>{
        return (
            <table className="table table-sm table-bordered align-middle bg-white">
                <thead className="align-middle table-secondary"  style={{
                        top: `${criteriaHeight}px`,
                        position: 'sticky',
                    }}>
                    <tr className='text-center'>
                        <th scope="col" style={{ width: "3%" }} >S.No</th>
                        <th scope="col" style={{ width: "8%" }} >Date</th>
                        <th scope="col" style={{ width: "10%" }}>Transaction ID</th>
                        {!props.match?.params?.id &&
                         <>
                         <th scope="col" style={{ width: "8%" }}>Asset</th>
                        <th scope="col" style={{ width: "8%" }}>Asset Code</th>
                         </> }
                        <th scope="col" style={{ width: "12%" }}>Meter</th>
                        <th scope="col" style={{ width: "6%" }}>Actual </th>
                        <th scope="col" style={{ width: "6%" }}>Cumulative </th>
                        <th scope="col" style={{ width: "9%" }}>Type of CL</th>
                        <th scope="col" style={{ width: "8%" }}>Site Name</th>
                        <th scope="col" style={{ width: "10%" }}>Date of Entry</th>
                        {props.match?.params?.id &&
                        <th scope="col" style={{ width: "12%" }}>Entered By</th>}
                    </tr>
                </thead>
                <tbody>
                {itemsData.loading 
                    ? <tr><td className='text-center' colSpan={11}><Loader /></td></tr>
                    : ((itemsData.items && itemsData.items.length > 0) 
                        ? itemsData.items.map((item,index) => {
                            return <tr className={['text-center', voucherData.transaction_id == item.transaction_id ? 'bg-light' : ''].join(' ')} key={index}>
                               
                                    <td className='text-center'>{itemsData.meta ? itemsData.meta.from + index : index}</td>
                                    <td>{DateService.dateTimeFormat(item.feed_datetime,'DD-MMM-YYYY hh:mm A') || "-"}</td>
                                    <td>{item.transaction_id}</td>
                                     {!props.match?.params?.id && <>
                                     <td>{item.name || "-"  }</td>
                                    <td>{item.asset_code || "-"  }</td>
                                    </> }
                                    <td className="text-end" >
                                        {item.reading && item.reading.length > 0 ? (
                                            item.reading.map((i, index) => <span key={index} >{i.label} ({i.unit})  <br/></span>)
                                        ) : (
                                            "-"
                                        )}
                                    </td>
                                      <td className="text-end" >
                                        {item.reading && item.reading.length > 0 ? (
                                            item.reading.map((i, index) => <span key={index} >{i.reading}  <br/></span>)
                                        ) : (
                                            "-"
                                        )}
                                    </td>
                                      <td className="text-end" >
                                        {item.reading && item.reading.length > 0 ? (
                                            item.reading.map((i, index) => <span>{i.cumulative}  <br/></span>)
                                        ) : (
                                            "-"
                                        )}
                                    </td>

                                    <td>{item.cl_type || "-"  }</td>
                                    <td>{item.site || "-"  }</td>
                                    
                                    <td>{item.created_at && DateService.dateFormat(item.created_at,'DD-MMM-YYYY hh:mm A')}</td>
                                      {props.match?.params?.id &&
                                    <td>{item.created_by?.full_name || "-"  }</td>}
                               
                            </tr>
                        })
                        : <tr><td className='text-center' colSpan={11}>No Record Found</td></tr>  )
                }
                </tbody>
            </table> )
    }
    const   assetCardHandler                     =   (collapse = true)  =>  {
            new Collapse(document.getElementById('assetCard'));
            if(document.getElementById('pageTbl')) {
                document.getElementById('pageTbl').scroll({ top: 0, behavior: 'smooth' });
            }
        }


    const voucherListJsx                =   ()  =>  {
        return <>
            <div ref={criteriaRef}
                style={{
                    position: 'sticky',
                    top: 0,
                    background: 'white',
                }}>
                <DisplaySearchCriteria searchedElems={formSearchedElems} onClearFilter={handleSearchClear} />
            </div>
               {props.match?.params?.id 
               ? 
               <div className='table-responsive' style={{ maxHeight: formSearchedElems && formSearchedElems.length > 0 ? "55vh" : "65vh"  }}>
                    {counterlogTablejsx()}
                </div>
                :
               counterlogTablejsx() }
             
            <DisplayListPagination meta={itemsData.meta} onPageChange={(e) => loadItemsData(e.selected + 1)} />
        </>
    }
    
    const topRightHeaderJsx             =   ()  =>  {
        return <>
            <button type="button" className="btn btn-secondary" disabled={itemsData.loading} onClick={counterlogSearchModalOpen} >
                <TapIcon.imageIcon icon={TapIcon.SearchIcon} />
            </button>
        </>
    }

    const pageHeading                   =   () => {
        return  <PageHeader title="CounterLog - List" name="Counterlog History" rightTopHeadingJsx={topRightHeaderJsx()} />
    }
    const   counterlogSearchModalJsx         =   ()  =>  {
        return (
             <div className="modal fade" id={modalId} tabIndex="-1" ref={counterlogSearchModalElem}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Counterlog Search</h5>
                        <button type="button" className="btn-close" onClick={counterlogSearchModalClose} aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={counterlogSearchFormSubmit} id={formId}>
                            <div className="modal-body">
                                <div className="row mb-3">
                                    <label className="col-sm-3 col-form-label col-form-label-sm text-end">Transaction ID</label>
                                    <div className="col-sm-8">
                                        <TapInput
                                            name="search_transaction_id"
                                            className="form-control form-control-sm"
                                            placeholder="Transaction ID"
                                            autoComplete="off"
                                            value={counterlogSearchForm.search_transaction_id}
                                            onChange={(e) => formInputHandler(e, "counterlogSearchForm")}
                                        />
                                    </div>
                                </div>
                                <div className='row mb-3'>
                                    <label className="col-sm-3 col-form-label col-form-label-sm text-end">Site</label>
                                    <div className="col-sm-8">
                                        <TapSelect
                                            options={iam_group_sites}
                                            changeEvent={o => setCounterlogSearchForm(d => ({...d, search_site_ids : o.map(e => e.value)}))}
                                            isSearchable={true}
                                            isClearable={true}
                                            isMulti={true}
                                            value={iam_group_sites.filter(s => counterlogSearchForm.search_site_ids.includes(s.value))}
                                            placeholder="Select Site"
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />
                                    </div>
                                </div>
                                      {!assetId && <><div className="row mb-3">
                                    <label className="col-sm-3 col-form-label col-form-label-sm text-end">Asset</label>
                                    <div className="col-sm-8">
                                        <InputAssetSearch
                                            containerHeight="30px"
                                            fontSize="93%"
                                            changeEvent={(selectedOption) => {
                                                tapSelectChange(selectedOption, 'counterlogSearchForm', 'search_asset_ids');
                                                setSearchedAssets(selectedOption && selectedOption.length > 0 ? selectedOption : [] )
                                            }}
                                            isMulti={true}
                                            menuPlacement="top"
                                            value={searchedAssets.length > 0 ? searchedAssets.map(a => { a.label = a.display_label; return a; }) : []}
                                        />
                                    </div>
                                </div>
                                    <div className="row my-3">
                                    <label className="col-sm-3 col-form-label text-end">Asset Type</label>
                                    <div className="col-sm-8">
                                        <TapSelect
                                            options={iam_asset_types}
                                            changeEvent={(selectedOption) => {
                                                tapSelectChange(selectedOption, 'counterlogSearchForm', 'search_asset_type_ids');
                                            }}
                                            isSearchable={true}
                                            isClearable={true}
                                            isMulti={true}
                                            value={iam_asset_types.filter(s => counterlogSearchForm.search_asset_type_ids.includes(s.value))}
                                            placeholder="Select Asset Type"
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />
                                    </div>
                                </div>
                                <div className="row my-3">
                                    <label className="col-sm-3 col-form-label text-end">Asset Matrix</label>
                                    <div className="col-sm-8">
                                        <TapSelect
                                            options={iam_asset_matrix}
                                            changeEvent={(selectedOption) => {
                                                tapSelectChange(selectedOption, 'counterlogSearchForm', 'search_asset_matrix_ids');
                                            }}
                                            isSearchable={true}
                                            isClearable={true}
                                            isMulti={true}
                                            value={iam_asset_matrix.filter(s => counterlogSearchForm.search_asset_matrix_ids.includes(s.value))}
                                            placeholder="Select Asset Matrix"
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />
                                    </div>
                                </div>
                                </>}
                                <div className='row mb-3'>
                                    <label className="col-sm-3 col-form-label col-form-label-sm text-end">Transaction Delay</label>
                                    <div className="col-sm-8">
                                        <TapSelect
                                            options={allTransactionDelay}
                                            changeEvent={(selectedOption) => tapSelectChange(selectedOption, 'counterlogSearchForm', 'activity_transaction_delay')}
                                            isSearchable={true}
                                            isClearable={true}
                                            value={allTransactionDelay.find(s => counterlogSearchForm.activity_transaction_delay == s.value)}
                                            placeholder="Select Transaction Delay"
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />
                                    </div>
                                </div>
                                 
                                <div className="row my-3 align-items-center">
                                    <label className="col-sm-3 col-form-label col-form-label-sm text-end">Date of Entry</label>
                                    <div className="col-sm-8">
                                        <PeriodSelectionWithCustom
                                            periods={allPeriods || []}
                                            value={counterlogSearchForm.entry_date_range}
                                            startDate={counterlogSearchForm.entry_date_range_start }
                                            endDate={counterlogSearchForm.entry_date_range_end}
                                            className="form-control-sm"
                                            containerHeight="30px"
                                            fontSize="93%"
                                            onSelectPeriod={(period, startDate, endDate) => {
                                                setCounterlogSearchForm(prev => ({
                                                    ...prev,
                                                    entry_date_range: period,
                                                    entry_date_range_start : startDate || null,
                                                    entry_date_range_end: endDate || null
                                                }));
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="row my-3 align-items-center">
                                    <label className="col-sm-3 col-form-label col-form-label-sm text-end">Transaction Period</label>
                                    <div className="col-sm-8">
                                        <PeriodSelectionWithCustom
                                            periods={allPeriods || []}
                                            value={counterlogSearchForm.date_range}
                                            startDate={counterlogSearchForm.date_range_start}
                                            endDate={counterlogSearchForm.date_range_end}
                                            onSelectPeriod={(period, startDate, endDate) => {
                                                setCounterlogSearchForm(prev => ({
                                                    ...prev,
                                                    date_range: period,
                                                    date_range_start: startDate || null,
                                                    date_range_end: endDate || null
                                                }));
                                            }}
                                            className="form-control-sm"
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={counterlogSearchModalClose}>Close</button>
                                <button type="submit" className="btn btn-primary">Search</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        );
    }

    return <ApplicationLayout>
        <Helmet><title>CounterLog Listing</title></Helmet>
        {props.match?.params?.id
            ? <>
                {pageTitleBarJsx()}
                {horizontalAssetCardJsx()}
                <div style={{ paddingTop: "4px" }}>
                    <div className="page_title row m0" style={{ height: "45px" }}>
                        <div className="col-sm-6">
                            <h3 style={{ paddingTop: "13px" }}>Counterlog History</h3>
                        </div>
                        <div className='col-sm-2 '>
                            <button type="button" className="btn btn-primary btn-sm" role="button" onClick={assetCardHandler}> Asset Card</button>
                        </div>
                        <div className='col-sm-4 text-end mt7 '>
                            <button type="button" className="btn btn-secondary" disabled={itemsData.loading} onClick={counterlogSearchModalOpen} >
                                <TapIcon.imageIcon icon={TapIcon.SearchIcon} />
                            </button>
                        </div>
                    </div>
                </div>
                <div className="container-fluid pl0 pr13 overflow-hidden">
                    <div className="page_containt row">
                        <div className='pl16 col-12 pr0'>{voucherListJsx()}</div>
                    </div>
                </div>
            </>
            : <>
                {pageHeading()}
                <div className="container-fluid pl5">
                    <div className='page_containt row'>
                        <div style={{ paddingTop: "4px" }} className='pageTbl col-sm-12' >{voucherListJsx()}</div>
                    </div>
                </div>
            </>
        }
        {counterlogSearchModalJsx()}
    </ApplicationLayout>

});

export default CounterlogHistoryList;

